import { Box, Divider, Typography, useTheme } from "@mui/material";
import React from "react";

const Fields = [
  {
    value: "yearOfManufacture",
    label: "MANUFACTURE",
  },
  {
    value: "name",
    label: "BRAND",
  },
  {
    value: "model",
    label: "MODEL",
  },
  {
    value: "variant",
    label: "VARIANT",
  },
  {
    value: "engineNumber",
    label: "ENGINE NUMBER",
  },
  {
    value: "color",
    label: "EXTERIOR COLOR",
  },
  {
    value: "vehicleNumber",
    label: "VEHICLE NUMBER",
  },
  {
    value: "insuranceExpiryDate",
    label: "INSURANCE",
    type: "date",
  },
  {
    value: "kmsDriven",
    label: "KMS",
  },
];

const DescriptionCard = ({ data }) => {
  const theme = useTheme();

  return (
    <div className="md:w-2/5 w-full md:px-10 mt-6 md:mt-0">
      <h2
        className="text-3xl my-0 title-font tracking-widest"
        style={{
          color: theme.palette.secondary[100],
        }}
      >
        {data.name} &nbsp;{data.model}
      </h2>
      <Divider
        sx={{
          width: "100%",
          height: "1px",
          margin: "1rem 0",
        }}
        className="bg-slate-800/10"
      />

      <div className="container bg-slate-400/10 p-4 m-2">
        <Typography
          variant="h4"
          style={{ color: theme.palette.secondary[200] }}
          className="font-extrabold"
        >
          DESCRIPTION
        </Typography>
        {/* underline DESCR */}
        <Divider
          sx={{
            width: "10%",
            height: "2px",
            margin: "1rem 0",
          }}
          className="bg-slate-800"
        />
        {Fields.map((field) => (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              borderRadius: "1rem",
              width: "100%",
              margin: "0",
              padding: "0.4rem 0",
            }}
            key={field.value}
          >
            <Typography
              style={{
                color: theme.palette.secondary[100],
              }}
              className="font-bold"
            >
              {field.label}
            </Typography>
            <Typography
              style={{
                color: theme.palette.primary[300],
              }}
              className="font-bold"
            >
              {field.type === "date"
                ? new Date(data[field.value]).toDateString({
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                : data[field.value]
                ? data[field.value]
                : "N/A"}
            </Typography>
          </Box>
        ))}
      </div>
      <div className="price-container">
        <span
          className="font-medium text-2xl px-2"
          style={{
            color: theme.palette.secondary[200],
          }}
        >
          {/* transform price with locale */}
          {data.price.toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
          })}
        </span>
      </div>
    </div>
  );
};

export default DescriptionCard;
